module.exports = __webpack_public_path__ + "static/img/leisure.6f4b5f32.svg";